import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import { Button } from '../../Common/ui/button'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import { useTranslation } from 'react-i18next'
import { useCommonStore } from '../../Common/store/CommonStore'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import Racilist from './Components/raciLists'
import SelectInput from 'src/Common/ui/selectInput'
import { editRegulatoryBodyOptions, INFORMED_DEPARTMENT, INFORMED_RACIID, INFORMED_ROLE } from 'src/Entities/Governance'
import { FormControlLabel, IconButton, Tooltip } from '@mui/material'
import { IOSSwitch } from 'src/Common/ui/switch'
import { RadioGroup, RadioGroupItem } from 'src/Common/ui/radio-group'
import DateInput from 'src/Common/ui/dateInput'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import { useOnboardingStore } from 'src/Containers/Onboarding/Store/OnboardingStore'
import { useLocation } from 'react-router'
import { MENU_TYPE_GOVERNANCE } from 'src/Entities/MainContainerTypes'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const RegulatoryBodyDrawer = ({ onboard, getState, setEditState, editState, setEditNodes, setShowSubmitButton }) => {
    const { t } = useTranslation()
    const { control, formState: { errors, isSubmitting, isLoading }, reset, handleSubmit } = useForm({ mode: 'onChange' })
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const { getAllRole } = useCommonStore()
    const updateData = (data) => {

    }

    const [ editNode, setEditNode ] = useState({})
    const [ raciiMatrices, setRaciiMatrices ] = useState([])
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const { addOrgRegulation } = useGovernanceStore()
    const { getOrgRegulation } = useOnboardingStore()
    const governanceLoading = useGovernanceStore(state => state.governanceLoading)
    const getOrgRegulationLoading = useOnboardingStore(state => state.getOrgRegulationLoading)
    const loading = (governanceLoading || getOrgRegulationLoading) || false
    const [ status, setStatus ] = useState(1)
    const [ tempRaciMatrix, setTempRaciMatrix ] = useState([])
    useEffect(() => {
        setStatus(getState?.expiryDate === null ? 1 : 2)
        setEditNode({
            organizationId: getState.organizationId,
            typeId: getState.typeId || 1,
            regulationId: getState.regulationId,
            orgRegulationId: getState.id,
            raciiMatrices: getState?.raciiMatrices,
            durationId: getState.durationId || 1,
            auditId: getState.auditId || 1,
            isRiskFactors: getState.isRiskFactors || true,
            isComplianceFactors: getState.isComplianceFactors || true,
            contextId: getState.contextId,
            expiryDate: getState.expiryDate,
            status: getState.status
        })
        const matrices = JSON.parse(JSON.stringify(getState.raciiMatrices || []))
        for (let i = 1; i <= 4; i++) {
            const find = getState.raciiMatrices?.find(ele => ele.raciId === i)
            if (!find) {
                matrices?.splice(i - 1, 0,
                    {
                        department: i === INFORMED_RACIID ? INFORMED_DEPARTMENT[0].label : 'nodata',
                        departmentId: i === INFORMED_RACIID ? INFORMED_DEPARTMENT[0].value : null,
                        orgRegulationId: getState.id,
                        organizationId: getState.organizationId,
                        orgId: getState.organizationId,
                        profilePic: null,
                        raciId: i,
                        role: i === INFORMED_RACIID ? INFORMED_ROLE[0].label : null,
                        roleId: i === INFORMED_RACIID ? INFORMED_ROLE[0].value : null,
                        status: null,
                        user: null,
                        userId: null
                    }
                )
            }
        }
        setTempRaciMatrix(matrices.sort((a, b) => a.raciId - b.raciId))
        setRaciiMatrices(matrices.sort((a, b) => a.raciId - b.raciId))
    }, [getState])
    const orgId = localStorage.getItem('orgId')

    useEffect(() => {
        getAllRole(orgId)
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    const onValueSelectChange = (value, name) => {
        const data = { ...editNode, [name]: value }
        setEditNode(data)
        updateData(data)
    }

    const onSelectedTableValueChange = (keyName, objName, value) => {
        const raciMatrix = {
            ...editNode.raciMatrix,
            [keyName]: {
                ...editNode.raciMatrix[keyName],
                [objName]: value
            }
        }
        const data = {
            ...editNode,
            raciMatrix
        }
        setEditNode(data)
        updateData(data)
    }

    const onSwitchChange = (event) => {
        const data = { ...editNode, expiryDate: editNode.expiryDate ? null : new Date() }
        setStatus(status === 1 ? 2 : 1)
        setEditNode(data)
        updateData(data)
    }

    const onSubmit = (e) => {
        if (onboard) {
            setShowSubmitButton(true)
        }
        const finalData = editNode
        const matrices = raciiMatrices.filter(ele => ele.department !== 'nodata')
        finalData.raciiMatrices = matrices
        addOrgRegulation(finalData, editNode.organizationId, 1).then(() => [
            getOrgRegulation(editNode.organizationId, 1, bodyType)
        ])
        localStorage.setItem('raciiMatrices', JSON.stringify(raciiMatrices))
        setEditState({ ...editState, right: false })
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }
        setEditState({ ...editState, [anchor]: open })
    }
    const minDate = new Date()
    // minDate.setHours(0, 0, 0, 0)
    // minDate.setDate(minDate.getDate() - 1)

    const handleCancelClose = () => {
        setEditState({ ...editState, right: false })
        setEditNodes({})
        reset()
    }

    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 1.8, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState?.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <Box className="h-[100%] relative">
                    <div className="flex justify-between items-center pr-4 border-b-2">
                        <h2 className="p-4 text-xl font-bold text-primary">{t(`${onboard ? 'Add' : 'Edit'} ${getState?.regulation}`)}</h2>
                        <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton onClick={() => handleCancelClose()} aria-label="close" disabled={isSubmitting || isLoading || loading}>
                                <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className='flex flex-col h-[90%] justify-between'>
                        <div className='h-[90%]'>
                            <div className="grid gap-4 mb-2 p-4">
                                {
                                    Object.keys(editRegulatoryBodyOptions).map((item, i) => {
                                        if (item === 'Status') {
                                            return (
                                                <>
                                                    <div className='block pt-5 relative' key={i}>
                                                        {/* <div className='border-b-[1px] absolute w-[115%] left-[-16px] top-0'></div> */}
                                                        <div>
                                                            {getState?.regulation && <Racilist type={MENU_TYPE_GOVERNANCE} tempRaciMatrix={tempRaciMatrix} getState={getState} reset={reset} raciiMatrices={raciiMatrices} setRaciiMatrices={setRaciiMatrices} editNode={editNode} control={control} errors={errors} onSelectedTableValueChange={onSelectedTableValueChange} loading={loading}/>}
                                                        </div>
                                                        {!onboard && <>
                                                            <div className='border-b-[1px] absolute w-[115%] left-[-16px]'></div>
                                                            <div className='pt-5'><p className='grc-label block'>{item}</p>
                                                                <FormControlLabel
                                                                    control={<IOSSwitch sx={{ my: 2, ml: 2, mr: 1 }} checked={!editNode.expiryDate} onChange={onSwitchChange} />}
                                                                    label={!editNode.expiryDate ? editRegulatoryBodyOptions[item].options[0] : editRegulatoryBodyOptions[item].options[1]}
                                                                />
                                                                <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2} mt={2}>
                                                                    <Box gridColumn='1'>
                                                                        {!editNode.expiryDate
                                                                            ? null
                                                                            : (<><Controller
                                                                                rules={{ required: 'This field is Required' }}
                                                                                control={control}
                                                                                errors={errors}
                                                                                name='regExpyDaate'
                                                                                render={({ field: { onChange } }) => (<Box gridColumn="span 4">
                                                                                    <DateInput
                                                                                        label="Effective Date"
                                                                                        required
                                                                                        name='regExpyDaate'
                                                                                        value={editNode.expiryDate}
                                                                                        onValueChange={(e) => {
                                                                                            const val = e
                                                                                            onChange(val)
                                                                                            onValueSelectChange(val, 'expiryDate')
                                                                                        }}
                                                                                        minDate={minDate}
                                                                                    />
                                                                                </Box>)}
                                                                            />
                                                                            <p className='grc-error-msg text-danger'>{errors.regExpyDaate?.message}</p>
                                                                            </>
                                                                            )
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            </div>
                                                        </>}
                                                    </div>
                                                </>
                                            )
                                        } else {
                                            if (item !== 'Duration' && item !== 'Audit Required') {
                                                return (
                                                    <>
                                                        { onboard && item === 'Type' &&
                                                            <div key={i}>
                                                                <p className='risk-content-title' style={{ margin: 0, whiteSpace: 'nowrap' }}>{item}</p>
                                                                <RadioGroup className='flex space-x-6 mt-5' value={editNode[editRegulatoryBodyOptions[item].key]} required={editNode[editRegulatoryBodyOptions[item].key]}
                                                                    onValueChange={(e) => {
                                                                        const value = e
                                                                        onValueSelectChange(value, editRegulatoryBodyOptions[item].key)
                                                                    }}>
                                                                    {
                                                                        editRegulatoryBodyOptions[item].options.map((option, i) => {
                                                                            return (
                                                                                <div key={i} className='flex items-center space-x-2'>
                                                                                    <RadioGroupItem value={option.value} />
                                                                                    <label className='text-sm'>{option.label}</label>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </RadioGroup>
                                                                <p className='grc-error-msg text-danger'>{errors && 'actions' && errors.actions?.message}</p>
                                                            </div>
                                                        }
                                                        { !onboard &&
                                                            <div key={i}>
                                                                <p className='risk-content-title' style={{ margin: 0, whiteSpace: 'nowrap' }}>{item}</p>
                                                                <RadioGroup className='flex space-x-6 mt-5' value={editNode[editRegulatoryBodyOptions[item].key]} required={editNode[editRegulatoryBodyOptions[item].key]}
                                                                    onValueChange={(e) => {
                                                                        const value = e
                                                                        onValueSelectChange(value, editRegulatoryBodyOptions[item].key)
                                                                    }}>
                                                                    {
                                                                        editRegulatoryBodyOptions[item].options.map((option, i) => {
                                                                            return (
                                                                                <div key={i} className='flex items-center space-x-2'>
                                                                                    <RadioGroupItem value={option.value} />
                                                                                    <label className='text-sm'>{option.label}</label>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </RadioGroup>
                                                                <p className='grc-error-msg text-danger'>{errors && 'actions' && errors.actions?.message}</p>
                                                            </div>
                                                        }
                                                    </>

                                                )
                                            } else {
                                                return (
                                                    <> {!onboard && <Box key={i}>
                                                        <SelectInput
                                                            key={i}
                                                            label={item}
                                                            control={control}
                                                            errors={errors}
                                                            name="category"
                                                            placeholder="Select"
                                                            onValueChange={(value) => onValueSelectChange(value, editRegulatoryBodyOptions[item].key)}
                                                            value={editNode[editRegulatoryBodyOptions[item].key]}
                                                            options={editRegulatoryBodyOptions[item].options}
                                                            className='!w-[80%]'
                                                        />
                                                    </Box>}
                                                    </>
                                                )
                                            }
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className='absolute bottom-[16px] right-[20px]'>
                        <div className="flex justify-end space-x-4">
                            <Button
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                onClick={() => {
                                    handleCancelClose()
                                }}
                                disabled={loading}
                            >
                                <RxCross2 className="mr-2" size={18} /> {t('Cancel')}
                            </Button>
                            <Button onClick={handleSubmit(onSubmit)} disabled={isSubmitting || isLoading || loading}>
                                <LiaSaveSolid className="mr-2" size={15} />
                                {isSubmitting || isLoading || loading ? t('Saving...') : t('Save')}
                            </Button>
                        </div>
                    </div>
                </Box>
            </SwipeableDrawer>
        </div>
    )
}

RegulatoryBodyDrawer.propTypes = {
    nodes: PropTypes.object,
    editNode: PropTypes.object,
    setEditNode: PropTypes.func,
    currentNode: PropTypes.object,
    setEditState: PropTypes.func,
    editState: PropTypes.object,
    tableBody: PropTypes.object,
    onEdit: PropTypes.func,
    childNodeCount: PropTypes.number,
    setTableBody: PropTypes.func,
    onSelectedTableValueChange: PropTypes.func,
    onboard: PropTypes.any,
    getState: PropTypes.any,
    setShowSubmitButton: PropTypes.any,
    setEditNodes: PropTypes.any
}

export default RegulatoryBodyDrawer
